export const dummyCustomerAddress = [
  {
    id: '3e64e434-3fbe-4cad-bdfb-f368398a8383',
    customer_id: '3e64e434-3fbe-4cad-bdfb-f368398a8383',
    first_name: 'Jhon',
    last_name: 'Doe',
    phone: '628987654321',
    area: '312345678',
    address: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
    pinpoint: '{"lat":"","long":""}',
    created_at: '2024-11-14T03:57:44.252Z',
    updated_at: '2024-11-14T03:57:44.252Z',
    is_default: true,
    area_name: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
    zipcode: '12345',
  },
  {
    id: '40f84e28-3602-4072-99d3-9c2b017e60b7',
    customer_id: '40f84e28-3602-4072-99d3-9c2b017e60b7',
    first_name: 'Rose',
    last_name: 'Marry',
    phone: '628123456789',
    area: '3212345678',
    address: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
    pinpoint: '{"lat":"","long":""}',
    created_at: '2024-11-14T01:15:42.993Z',
    updated_at: '2024-11-14T03:57:44.252Z',
    is_default: false,
    area_name: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
    zipcode: '12345',
  },
];
